const firebaseConfig = {
    apiKey: "AIzaSyBhMzl8pCh0kb0hrc6RzAVGo_o34WwFjU8",
    authDomain: "complete-website-baa23.firebaseapp.com",
    projectId: "complete-website-baa23",
    storageBucket: "complete-website-baa23.appspot.com",
    messagingSenderId: "526186578113",
    appId: "1:526186578113:web:df17948ef82f83ddeb5440"
  };

  export default firebaseConfig;